export enum CONSTANTS {
  GET_OIDC_USER_TOKEN = 'GET_OIDC_USER_TOKEN',
}

export type OidcUserActions = GetOidcUserAction

export type OidcUserStoreState = { token: string }
type GetOidcUserAction = {
  type: CONSTANTS.GET_OIDC_USER_TOKEN
  token: string
}
